import { render, staticRenderFns } from "./ContactDetailsItem.vue?vue&type=template&id=71367b5c&scoped=true&"
import script from "./ContactDetailsItem.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsItem.vue?vue&type=style&index=0&id=71367b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71367b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71367b5c')) {
      api.createRecord('71367b5c', component.options)
    } else {
      api.reload('71367b5c', component.options)
    }
    module.hot.accept("./ContactDetailsItem.vue?vue&type=template&id=71367b5c&scoped=true&", function () {
      api.rerender('71367b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/ContactDetailsItem.vue"
export default component.exports